"use strict";

document.querySelectorAll('.menu__button').forEach(function (button) {
  button.addEventListener('click', function () {
    var parent = button.closest('.menu__category');
    if (parent) {
      var menu = parent.querySelector('.menu__block');
      button.classList.toggle('active');
      if (menu) {
        menu.classList.toggle('active');
      }
    }
    toggleHeaderState();
  });
});
document.addEventListener('click', function (e) {
  document.querySelectorAll('.menu__category').forEach(function (category) {
    if (!category.contains(e.target)) {
      var button = category.querySelector('.menu__button');
      var menu = category.querySelector('.menu__block');
      button === null || button === void 0 || button.classList.remove('active');
      menu === null || menu === void 0 || menu.classList.remove('active');
    }
  });
  toggleHeaderState();
});
function toggleHeaderState() {
  var header = document.querySelector('.header');
  var overlay = document.querySelector('.over-menu');
  var hasActive = document.querySelector('.menu__button.active');
  var isDesktop = window.innerWidth > 1199;
  if (hasActive) {
    header === null || header === void 0 || header.classList.add('open-menu');
    if (overlay && isDesktop) overlay.style.display = 'block';
  } else {
    header === null || header === void 0 || header.classList.remove('open-menu');
    if (overlay) overlay.style.display = 'none';
  }
}
document.querySelectorAll('.mobile-menu__button').forEach(function (button) {
  button.addEventListener('click', function () {
    var menu = document.querySelector('.header__nav');
    button.classList.toggle('active');
    document.querySelector('body').classList.toggle('mobile-menu-open');
    if (menu) {
      menu.classList.toggle('active');
    }
  });
});